import { useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import carByIdQuery from "../../graphql/query/getCarsForSaleById.query";

export const useProductView = () => {
  const { id: productId } = useParams();

  const { data, error, loading } = useQuery(carByIdQuery, {
    variables: {
      carid: parseInt(productId!),
    },
  });

  if (loading) {
    // wait until done loading but cant render anything because this is just a function hmmm
  }

  if (error) {
    alert("ERROR OCCURRED WHILE TRYING TO LOAD DATA!");
  }

  const car = data?.carsForSaleById;
  return { car };
};
